<template>
  <div class="wg-row">
    <template v-if="title">
      <div class="vertical-height-div" style="height:10px;"></div>
      <div class="wg-row">
        <div class="com-anm22-app-text-xxl">
          {{ this.mode === 'edit'
          ? $anm22.strLang(lang, 'Edit contact', 'Modifica contatto')
          : $anm22.strLang(lang, 'New contact', 'Nuovo contatto')
          }}
        </div>
      </div>
      <div class="vertical-height-div" style="height:20px;"></div>
    </template>
    <!-- Nel caso di un nuovo contatto è necessario scegliere se questo è una persona o un'azienda -->
    <template v-if="!contact.type && mode === 'new'">
      <div class="wg-row" style="flex-wrap:nowrap;align-items:center;height:300px;">
        <div
          class="box"
          style="border-right:1px solid #ccc;cursor:pointer;"
          @click="$set(contact, 'type', 1)"
        >
          <img :src="$anm22.icons.getWorldIcon('userMaterial')" class="img" />
          <div class="mode-title">{{ $anm22.strLang(lang, 'Person', 'Persona') }}</div>
        </div>
        <div class="box" style="cursor:pointer;" @click="$set(contact, 'type', 2)">
          <img :src="$anm22.icons.getWorldIcon('workMaterial')" class="img" />
          <div class="mode-title">{{ $anm22.strLang(lang, 'Company', 'Azienda') }}</div>
        </div>
      </div>
    </template>
    <template v-else>
      <!-- NOME-->
      <div class="wg-col wg-xs-12 wg-sm-6 item">
        <div class="wg-row">
          <div class="wg-row">
            <div v-if="contact.type === 2 && mode === 'new'" class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Company', 'Azienda') }}</div>
            <div v-else class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Name', 'Nome') }}</div>
          </div>
          <input
            class="input-elem com-anm22-app-input-text"
            type="text"
            :placeholder="$anm22.strLang(lang, 'Name', 'Nome')"
            v-model="contact.firstName" 
            data-cy=contact-name-imput
          />
        </div>
      </div>
      <!-- COGNOME -->
      <div v-if="contact.type != 2" class="wg-col wg-xs-12 wg-sm-6 item">
        <div class="wg-row">
          <div class="wg-row">
            <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Surname', 'Cognome') }}</div>
          </div>
          <input
            class="input-elem com-anm22-app-input-text"
            type="text"
            :placeholder="$anm22.strLang(lang, 'Surname', 'Cognome')"
            v-model="contact.lastName"
            data-cy=contact-lastname-imput
          />
        </div>
      </div>
      <div class="vertical-height-div" style="height:7px;"></div>
      <!-- RUBRICA -->
      <div class="wg-row">
        <div class="wg-col wg-sm-6 wg-xs-12 item">
          <div class="wg-row">
            <div class="wg-row">
              <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Address book', 'Rubrica') }}</div>
            </div>
            <select class="input-elem com-anm22-app-select" v-model="contact.workOwner" data-cy=address-book-select>
              <option value="0">{{ $anm22.strLang(lang, 'Personal', 'Personale') }}</option>
              <option
                v-for="(work,index) in works"
                :key="'owner-'+index"
                :value="work.idWorldWork"
              >{{ work.name }}</option>
            </select>
          </div>
        </div>
        <div class="wg-col wg-sm-6 wg-xs-12 item">
          <div class="wg-row">
            <div class="wg-row">
              <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Type', 'Tipo') }}</div>
            </div>
            <select class="input-elem com-anm22-app-select" v-model="contact.type" data-cy=contact-type-select>
              <option
                v-for="(type,index) in [{value:'1',label: $anm22.strLang(lang, 'Person', 'Persona')},{value:'2',label:$anm22.strLang(lang, 'Work', 'Azienda')}]"
                :key="'t-'+index"
                :value="type.value"
              >{{ type.label }}</option>
            </select>
          </div>
        </div>
      </div>
      <div v-if="contact.type == 2 && mode == 'new'" class="wg-row">
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="wg-row">
          <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Referent', 'Referente') }}</div>
        </div>
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="wg-col wg-xs-12 wg-sm-6 item">
          <div class="wg-row">
            <div class="wg-row input-name">
              <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Name', 'Nome') }}</div>
            </div>
            <input
              class="input-elem com-anm22-app-input-text"
              type="text"
              :placeholder="'Nome'"
              v-model="referentFirstName"
              data-cy=referent-name-input
            />
          </div>
        </div>
        <!-- COGNOME REFERENTE -->
        <div class="wg-col wg-xs-12 wg-sm-6 item">
          <div class="wg-row">
            <div class="wg-row input-name">
              <div
                class="com-anm22-app-text-m"
              >{{ $anm22.strLang(lang, 'Surname', 'Cognome') }}</div>
            </div>
            <input
              class="input-elem com-anm22-app-input-text"
              type="text"
              :placeholder="'Cognome'"
              v-model="referentLastName"
              data-cy=referent-lastname-input
            />
          </div>
        </div>
      </div>
      <div class="vertical-height-div" style="height:7px;"></div>
      <!-- SESSO -->
      <template v-if="mode == 'edit'  || showOthers">
        <div v-if="contact.type != 2" class="wg-col wg-xs-12 wg-sm-6 item">
          <div class="wg-row">
            <div class="wg-row input-name">
              <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Gender', 'Genere') }}</div>
            </div>
            <div class="vertical-height-div" style="height:7px;"></div>
            <div class="wg-row input-row" style="aling-items:center;">
              <input
                id="gender-m"
                type="radio"
                :value="'m'"
                style="display:none;"
                v-model="contact.gender"
              />
              <label
                class="label-input-radio"
                for="gender-m"
              >{{ contact.gender === 'm' ? '✔' : '' }}</label>
              <div class="com-anm22-app-text-m" style="margin:0 5px;">M</div>
              <div class="com-anm22-horizontal-div" style="width: 20px;"></div>
              <input
                id="gender-f"
                type="radio"
                :value="'f'"
                style="display:none;"
                v-model="contact.gender"
              />
              <label
                class="label-input-radio"
                for="gender-f"
              >{{ contact.gender === 'f' ? '✔' : '' }}</label>
              <div class="com-anm22-app-text-m" style="margin:0 5px;">F</div>
            </div>
          </div>
        </div>
        <!-- DATA DI NASCITA -->
        <div v-if="contact.type != 2" class="wg-col wg-xs-12 wg-sm-6 item">
          <div class="wg-row">
            <div class="wg-row input-name">
              <div
                class="com-anm22-app-text-m"
              >{{ $anm22.strLang(lang, 'Birthday', 'Data di nascita') }}</div>
            </div>
            <div class="wg-row input-elem" style="aling-items:center;">
              <input class="com-anm22-app-input-date" type="date" v-model="birthday" />
            </div>
          </div>
        </div>
      </template>
      <div v-if="mode == 'edit' && contact.type == 2 && $anm22.getReferrerFlag(contact, $store) == 0" class="wg-row">
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="wg-row">
          <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Referent', 'Referente') }}</div>
        </div>
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="wg-col wg-xs-12 wg-sm-6 item">
          <div class="wg-row">
            <div class="wg-row input-name">
              <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Name', 'Nome') }}</div>
            </div>
            <input
              class="input-elem com-anm22-app-input-text"
              type="text"
              :placeholder="'Nome'"
              v-model="contact.referrerFirstName"
              data-cy=referent-name-input
            />
          </div>
        </div>
        <!-- COGNOME REFERENTE -->
        <div class="wg-col wg-xs-12 wg-sm-6 item">
          <div class="wg-row">
            <div class="wg-row input-name">
              <div
                class="com-anm22-app-text-m"
              >{{ $anm22.strLang(lang, 'Surname', 'Cognome') }}</div>
            </div>
            <input
              class="input-elem com-anm22-app-input-text"
              type="text"
              :placeholder="'Cognome'"
              v-model="contact.referrerLastName"
              data-cy=referent-lastname-input
            />
          </div>
        </div>
      </div>
      <template v-if="contact.type != 2">
        <div class="wg-col wg-xs-12 wg-sm-6 item">
          <div class="wg-row input-name">
            <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Job', 'Mansione') }}</div>
          </div>
          <div class="wg-row input-elem" style="aling-items:center;">
            <input
              class="input-elem com-anm22-app-input-text"
              type="text"
              :placeholder="$anm22.strLang(lang, 'Job', 'Mansione')"
              v-model="contact.otherContacts.job"
              data-cy=job-type-input
            />
          </div>
        </div>
        <div class="wg-col wg-xs-12 wg-sm-6 item">
          <div class="wg-row input-name">
            <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Company', 'Azienda') }}</div>
          </div>
          <div class="wg-row input-elem" style="aling-items:center;">
            <template v-if="hasCompanyHinting">
              <wg-search
                v-if="editingCompany"
                :stringInit="editingCompanyInit"
                :placeholder="$anm22.strLang(lang, 'Name', 'Nome')"
                :mode="'offline'"
                :searchFn="searchCompanies" 
                :debounceTime="2000"
                :clickFn="setCompanyContactClick"
                @searchClosed="setCompanyContactClose"
              ></wg-search>
              <input
                v-else
                class="input-elem com-anm22-app-input-text"
                type="text"
                :placeholder="$anm22.strLang(lang, 'Name', 'Nome')"
                :value="contact.company"
                @input="startCompanySearch"
                data-cy=business-name-input
              />
            </template>
            <input
              v-else
              class="input-elem com-anm22-app-input-text"
              type="text"
              :placeholder="$anm22.strLang(lang, 'Name', 'Nome')"
              v-model="contact.company"
            />
          </div>
        </div>
      </template>
      <!-- TELEFONO -->
      <div class="vertical-height-div" style="height:10px;"></div>
      <div class="wg-row">
        <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Phone', 'Telefono') }}</div>
        <img
          :title="$anm22.strLang(lang, 'Add other number', 'Aggiungi un altro numero ')"
          class="add"
          @click="addNumber = true; addInputPhone();"
          :src="$anm22.icons.getWorldIcon('add')"
          data-cy=add-phone-number-click
        />
      </div>
      <div class="vertical-height-div" style="height:10px;"></div>
      <!-- PREFISSO -->
      <div class="wg-col wg-xs-12 wg-sm-6 item">
        <div class="wg-row">
          <div class="wg-row input-name">
            <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Area code', 'Prefisso') }}</div>
          </div>
          <select class="input-elem com-anm22-app-select" v-model="contact.phoneAreaCode" data-cy=prefix-select>
            <option
              v-for="(obj,key,index) in $anm22.tableClasses.areaCode().getAll()"
              :key="'areaCode-'+index"
              :value="key"
            >{{ obj[lang] }}</option>
          </select>
        </div>
      </div>
      <!-- NUMERO -->
      <div class="wg-col wg-xs-12 wg-sm-6 item">
        <div class="wg-row">
          <div class="wg-row input-name">
            <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Number', 'Numero') }}</div>
          </div>
          <input
            class="input-elem com-anm22-app-input-text"
            type="text"
            :placeholder="$anm22.strLang(lang, 'Number', 'Numero')"
            v-model="contact.phoneNumber"
            data-cy=phone-number-input
          />
        </div>
      </div>
      <!-- ALTRI NUMERI CONTATTO -->
      <template v-if="addNumber">
        <div
          class="wg-row wg-xs-12"
          v-for="(phone,indexRow) in additionalData.phones"
          :key="'input-new-phoneRow'+ indexRow"
        >
          <div class="wg-col wg-xs-12 wg-sm-6 item">
            <div class="wg-row input-name">
              <div
                class="com-anm22-app-text-m"
              >{{ $anm22.strLang(lang, 'Area code (New)', 'Prefisso (Nuovo)') }}</div>
            </div>
            <select class="input-elem com-anm22-app-select" v-model="phone.phoneAreaCode" data-cy=new-prefix-select>
              <option
                v-for="(obj,key,index) in $anm22.tableClasses.areaCode().getAll()"
                :key="'areaCodeOtherNumberNew-'+index"
                :value="key"
              >{{ obj[lang] }}</option>
            </select>
          </div>
          <div class="wg-col wg-xs-12 wg-sm-6 item">
            <div class="wg-row">
              <div class="wg-row input-name">
                <div
                  class="com-anm22-app-text-m"
                >{{ $anm22.strLang(lang, 'Number (New)', 'Numero (Nuovo)') }}</div>
              </div>
              <input
                class="input-elem com-anm22-app-input-text"
                type="text"
                :placeholder="$anm22.strLang(lang, 'Number', 'Numero')"
                v-model="phone.phoneNumber"
                data-cy=new-phone-number-input
              />
              <img
                :src="$anm22.icons.getWorldIcon('deleteBlack')"
                :title="$anm22.strLang(lang, 'Remove', 'Rimuovi')"
                class="com-anm22-app-img-fixed-height-s"
                style="cursor:pointer;margin:11px;"
                @click="removeInputPhone(indexRow)"
              />
            </div>
          </div>
        </div>
      </template>
      <template v-if="contact.otherContacts && contact.otherContacts.phones">
        <div
          class="wg-row wg-xs-12"
          v-for="(phone,index) in contact.otherContacts.phones"
          :key="'input-phoneRow'+ index"
        >
          <div class="wg-col wg-xs-12 wg-sm-6 item" :key="'input-new-phoneAreaCode'+ index">
            <div class="wg-row input-name">
              <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Area code', 'Prefisso') }}</div>
            </div>
            <select class="input-elem com-anm22-app-select" v-model="phone.phoneAreaCode">
              <option
                v-for="(obj,key,index) in $anm22.tableClasses.areaCode().getAll()"
                :key="'areaCodeOtherNumber-'+index"
                :value="key"
              >{{ obj[lang] }}</option>
            </select>
          </div>
          <div class="wg-col wg-xs-12 wg-sm-6 item">
            <div class="wg-row">
              <div class="wg-row input-name">
                <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Number', 'Numero') }}</div>
              </div>
              <input
                class="input-elem com-anm22-app-input-text"
                type="text"
                :placeholder="$anm22.strLang(lang, 'Number', 'Numero')"
                v-model="phone.phoneNumber"
              />
              <img
                class="com-anm22-app-img-fixed-height-s"
                :src="$anm22.icons.getWorldIcon('deleteBlack')"
                style="cursor:pointer;margin:11px;"
                @click="deletePhone(index)"
              />
            </div>
          </div>
        </div>
      </template>
      <!-- ALTRI CONTATTI -->
      <!-- <input 
          type="button" 
          class="small"
      :value="$anm22.strLang(lang, '+ Add contact', '+ Aggiungi contatto')">-->
      <!-- <div class="vertical-height-div" style="height:10px;"></div> -->
      <!-- E-MAIL -->
      <div class="wg-col wg-xs-12 wg-sm-6 item">
        <div class="wg-row">
          <div class="wg-row input-name">
            <div class="com-anm22-app-text-m">{{ 'E-mail' }}</div>
            <img
              @click="addEmail = true;addInputEmail();"
              :title="$anm22.strLang(lang, 'Add e-mail', 'Aggiungi altra e-mail')"
              class="add"
              :src="$anm22.icons.getWorldIcon('add')"
              data-cy=add-address-mail-click
            />
          </div>
          <input
            class="input-elem com-anm22-app-input-text"
            type="text"
            :placeholder="'E-mail'"
            v-model="contact.email"
            data-cy=mail-address-input
          />
        </div>
      </div>
      <!--  EMAIL AGGIUNTIVE DEL CONTATTO -->
      <template v-if="contact.otherContacts && contact.otherContacts.emails">
        <div
          v-for="(email,index) in contact.otherContacts.emails"
          :key="'input-emails'+ index"
          class="wg-col wg-xs-12 wg-sm-6 item"
        >
          <div class="wg-row">
            <div class="wg-row input-name">
              <div class="com-anm22-app-text-m">{{ 'E-mail'}}</div>
            </div>
            <input class="input-elem com-anm22-app-input-text" type="text" v-model="email.address" />
            <img
              class="com-anm22-app-img-fixed-height-s"
              :src="$anm22.icons.getWorldIcon('deleteBlack')"
              style="cursor:pointer;margin:11px;"
              @click="deleteEmail(index)"
            />
          </div>
        </div>
      </template>
      <!-- CAMPI AGGIUNTA NUOVE EMAIL CONTATTO -->
      <template v-if="addEmail">
        <div
          v-for="(email,index) in additionalData.emails"
          :key="'input-new-emails'+ index"
          class="wg-col wg-xs-12 wg-sm-6 item"
        >
          <div class="wg-row">
            <div class="wg-row input-name">
              <div class="com-anm22-app-text-m">{{ 'E-mail (Nuova)' }}</div>
            </div>
            <input
              class="input-elem com-anm22-app-input-text"
              type="text"
              :placeholder="'E-mail'"
              v-model="email.address"
              data-cy=new-mail-address-input
            />
            <img
              :src="$anm22.icons.getWorldIcon('deleteBlack')"
              :title="$anm22.strLang(lang, 'Remove', 'Rimuovi')"
              class="com-anm22-app-img-fixed-height-s"
              style="cursor:pointer;margin:11px;"
              @click="removeInputEmail(index)"
            />
          </div>
        </div>
      </template>
      <div v-if="mode == 'new'" class="wg-row" style="margin-bottom:25px;">
        <input
          type="button"
          class="small"
          :value="$anm22.strLang(lang, 'Others', 'Altro')"
          @click="showOthers = ! showOthers"
          data-cy=details-button
        />
      </div>
      <!-- PEC -->
      <template v-if="mode == 'edit' || showOthers">
        <div class="wg-col wg-xs-12 wg-sm-6 item">
          <div class="wg-row">
            <div class="wg-row input-name">
              <div class="com-anm22-app-text-m">{{ 'PEC' }}</div>
            </div>
            <input
              class="input-elem com-anm22-app-input-text"
              type="text"
              :placeholder="'PEC'"
              v-model="contact.pec"
            />
          </div>
        </div>
         <div class="wg-col wg-xs-12 wg-sm-6 item">
          <div class="wg-row">
            <div class="wg-row input-name">
              <div
                class="com-anm22-app-text-m"
              >{{ $anm22.strLang(lang, 'Privacy Policy date', 'Approvazione Privacy Policy') }}</div>
            </div>
            <div class="wg-row input-elem" style="aling-items:center;">
              <input class="com-anm22-app-input-date" type="date" v-model="privacyPolicyDate" />
            </div>
          </div>
        </div>
        <!-- FB ID -->
        <div class="wg-col wg-xs-12 wg-sm-6 item">
          <div class="wg-row">
            <div class="wg-row input-name">
              <div
                class="com-anm22-app-text-m"
              >{{ $anm22.strLang(lang, 'Commercial Privacy Policy date', 'Approvazione Privacy Policy per uso commerciale') }}</div>
            </div>
            <div class="wg-row input-elem" style="aling-items:center;">
              <input class="com-anm22-app-input-date" type="date" v-model="commercialPrivacyPolicyDate" />
            </div>
          </div>
        </div>
        <!-- WEBSITE -->
        <div class="wg-col wg-xs-12 wg-sm-6 item">
          <div class="wg-row">
            <div class="wg-row input-name">
              <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Website', 'Sito web') }}</div>
            </div>
            <input
              class="input-elem com-anm22-app-input-text"
              type="text"
              :placeholder="'Website'"
              v-model="contact.website"
            />
          </div>
        </div>
        <!-- MY BUSINESS -->
        <div class="wg-col wg-xs-12 wg-sm-6 item">
          <div class="wg-row">
            <div class="wg-row input-name">
              <div class="com-anm22-app-text-m">{{ 'Google MyBusiness' }}</div>
            </div>
            <input
              class="input-elem com-anm22-app-input-text"
              type="text"
              :placeholder="'My Business'"
              v-model="contact.mybusiness"
            />
          </div>
        </div>
        <!-- FB PAGE -->
        <div class="wg-col wg-xs-12 wg-sm-6 item">
          <div class="wg-row">
            <div class="wg-row input-name">
              <div
                class="com-anm22-app-text-m"
              >{{ $anm22.strLang(lang, 'Facebook Page', 'Pagina Facebook') }}</div>
            </div>
            <input
              class="input-elem com-anm22-app-input-text"
              type="text"
              :placeholder="'Facebook'"
              v-model="contact.fbPage"
            />
          </div>
        </div>
        <!-- FB ID -->
        <div class="wg-col wg-xs-12 wg-sm-6 item">
          <div class="wg-row">
            <div class="wg-row input-name">
              <div
                class="com-anm22-app-text-m"
              >{{ $anm22.strLang(lang, 'Facebook ID', 'ID Facebook') }}</div>
            </div>
            <input
              class="input-elem com-anm22-app-input-text"
              type="text"
              :placeholder="'ID'"
              v-model="contact.fbId"
            />
          </div>
        </div>
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="wg-row">
          <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Billing', 'Fatturazione') }}</div>
        </div>
        <div class="vertical-height-div" style="height:10px;"></div>
        <!-- Tax code -->
        <div class="wg-col wg-xs-12 wg-sm-6 item">
          <div class="wg-row">
            <div class="wg-row input-name">
              <div
                class="com-anm22-app-text-m"
              >{{ $anm22.strLang(lang, 'Tax code', 'Codice fiscale') }}</div>
            </div>
            <input
              class="input-elem com-anm22-app-input-text"
              type="text"
              :placeholder="$anm22.strLang(lang, 'Tax code', 'Codice fiscale')"
              v-model="contact.taxCode"
            />
          </div>
        </div>
        <!-- Vat code -->
        <div class="wg-col wg-xs-12 wg-sm-6 item">
          <div class="wg-row">
            <div class="wg-row input-name">
              <div
                class="com-anm22-app-text-m"
              >{{ $anm22.strLang(lang, 'VAT code', 'Partita IVA') }}</div>
            </div>
            <input
              class="input-elem com-anm22-app-input-text"
              type="text"
              :placeholder="$anm22.strLang(lang, 'VAT code', 'Partita IVA')"
              v-model="contact.vatCode"
            />
          </div>
        </div>
        <!-- SDI -->
        <div class="wg-col wg-xs-12 wg-sm-6 item">
          <div class="wg-row">
            <div class="wg-row input-name">
              <div class="com-anm22-app-text-m">{{ 'SDI' }}</div>
            </div>
            <input
              class="input-elem com-anm22-app-input-text"
              type="text"
              :placeholder="'SDI'"
              v-model="contact.sdi"
            />
          </div>
        </div>
        <template v-if="contact.type == 2">
          <div class="vertical-height-div" style="height:10px;"></div>
          <!-- AZIENDA -->
          <div class="wg-col wg-xs-12 wg-sm-6 item">
            <div class="wg-row">
              <div class="wg-row input-name">
                <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Subsidiary of', 'Sussidiaria di') }}</div>
              </div>
              <div class="wg-row input-elem" style="aling-items:center;">
                <template v-if="hasCompanyHinting">
                  <wg-search
                    v-if="editingCompany"
                    :stringInit="editingCompanyInit"
                    :placeholder="$anm22.strLang(lang, 'Name', 'Nome')"
                    :mode="'offline'"
                    :searchFn="searchCompanies" 
                    :debounceTime="2000"
                    :clickFn="setCompanyContactClick"
                    @searchClosed="setCompanyContactClose"
                  ></wg-search>
                  <input
                    v-else
                    class="input-elem com-anm22-app-input-text"
                    type="text"
                    :placeholder="$anm22.strLang(lang, 'Name', 'Nome')"
                    :value="contact.company"
                    @input="startCompanySearch"
                    data-cy=business-name-input
                  />
                </template>
                <input
                  v-else
                  class="input-elem com-anm22-app-input-text"
                  type="text"
                  :placeholder="$anm22.strLang(lang, 'Name', 'Nome')"
                  v-model="contact.company"
                />
              </div>
            </div>
          </div>
        </template> 
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="wg-row">
          <div class="com-anm22-app-text-m">{{'CRM'}}</div>
        </div>
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="wg-col wg-xs-12 wg-sm-6 item">
          <div class="wg-row">
            <div class="wg-row input-name">
              <div class="com-anm22-app-text-m">{{$anm22.strLang(lang, 'Value', 'Valore')}}</div>
            </div>
            <input
              class="input-elem com-anm22-app-input-text"
              type="number"
              :placeholder="'Value'"
              v-model="contact.value"
            />
          </div>
        </div>
        <div class="wg-col wg-xs-12 wg-sm-6 item">
          <div class="wg-row">
            <div class="wg-row input-name">
              <div class="com-anm22-app-text-m">{{$anm22.strLang(lang, 'In', 'In pausa fino a')}}</div>
            </div>
            <div class="wg-row input-elem" style="aling-items:center;">
               <input class="com-anm22-app-input-date" type="date" v-model="pauseDate" />
            </div>
            <img v-if="contact.pauseDate != ''"
              :src="$anm22.icons.getWorldIcon('deleteBlack')"
              :title="$anm22.strLang(lang, 'Remove', 'Rimuovi')"
              class="com-anm22-app-img-fixed-height-s"
              style="cursor:pointer;margin:11px;"
              @click="contact.pauseDate = ''"
              />
          </div>
        </div>
      </template>
      <div class="wg-row" style="margin-bottom:10px;">
        <input
          type="button"
          class="small"
          :value="$anm22.strLang(lang, 'Save', 'Salva')"
          @click="save"
          data-cy=save-button
          
        />
        <template v-if="!title">
          <div class="com-horizontal-space" style="width:10px;"></div>
          <input
            type="button"
            class="small com-anm22-button-red"
            :value="$anm22.strLang(lang, 'Back', 'Annulla')"
            @click="$emit('closeForm')"
          />
        </template>
      </div>
    </template>
  </div>
</template>

 <script>
import _ from "lodash";
import { mapState } from "vuex";

export default {
  props: {
    mode: {
      type: String,
      default: "edit"
    },
    title: {
      type: Boolean,
      default: true
    },
    contactRef: {
      type: Object,
      default: () => {
        return {
          workOwner:0,
          otherContacts: {}
        };
      }
    },
    ownerSelectable: {
      type: Boolean,
      default: true
    },
    afterSaveFn: {
      type: Function
    },
    hasCompanyHinting: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      referentFirstName: "",
      referentLastName: "",
      showOthers: false,
      addEmail: false,
      addNumber: false,
      contact: {
        ...this.contactRef
      },
      additionalData: {
        emails: [],
        phones: []
      },
      editingCompany: false,
      editingCompanyInit: ''
      // items: []
    };
  },
  computed: {
    ...mapState({
      lang: state => state.lang,
      user: state => state.auth.user
    }),
    works() {
      return this.$store.getters["employments/getByUser"](this.user.idWorldUser).map(e => this.$store.getters['works/get'](e.work))
      //return this.$store.getters["employments/getWorks"];
    },
    owner: {
      get() {
        return !this.contact.workOwner ? 0 : this.contact.workOwner;
      },
      set(newVal) {
        this.contact.workOwner = newVal;  
      }
    },
    birthday: {
      get() {
        if (this.contact.birthday !== "") {
          return this.$moment.unix(this.contact.birthday).format("YYYY-MM-DD");
        } else {
          return;
        }
      },
      set: _.debounce(function(newDate) {
        let ts = Number(
          this.$moment(newDate)
            .utc()
            .format("X")
        );
        if (isNaN(ts)) {
          this.contact.birthday = "";
        } else if (ts) {
          this.contact.birthday = ts;
        }
      }, 2000)
    },
    pauseDate: {
      get() {
        if (this.contact.pauseDate !== "") {
          return this.$moment.unix(this.contact.pauseDate).format("YYYY-MM-DD");
        } else {
          return;
        }
      },
      set(newDate) {
        let ts = Number(
          this.$moment(newDate)
            .utc()
            .format("X")
        );
        if (isNaN(ts)) {
          this.contact.pauseDate = "";
        } else if (ts) {
          this.contact.pauseDate = ts;
        }
      }
    },
    privacyPolicyDate: {
      get() {
        if (this.contact.privacyPolicyDate !== "") {
          return this.$moment.unix(this.contact.privacyPolicyDate).format("YYYY-MM-DD");
        } else {
          return;
        }
      },
      set: _.debounce(function(newDate) {
        let ts = Number(
          this.$moment(newDate)
            .utc()
            .format("X")
        );
        if (isNaN(ts)) {
          this.contact.privacyPolicyDate = "";
        } else if (ts) {
          this.contact.privacyPolicyDate = ts;
        }
      }, 2000)
    },
    commercialPrivacyPolicyDate: {
      get() {
        if (this.contact.commercialPrivacyPolicyDate !== "") {
          return this.$moment.unix(this.contact.commercialPrivacyPolicyDate).format("YYYY-MM-DD");
        } else {
          return;
        }
      },
      set: _.debounce(function(newDate) {
        let ts = Number(
          this.$moment(newDate)
            .utc()
            .format("X")
        );
        if (isNaN(ts)) {
          this.contact.commercialPrivacyPolicyDate = "";
        } else if (ts) {
          this.contact.commercialPrivacyPolicyDate = ts;
        }
      }, 2000)
    }
  },
  methods: {
    searchCompanies(string) {
      const regexp = new RegExp(string, 'i');
      return this.$store.getters['contacts/getAll'].filter(
        c => 
          c.type == 2 &&
          c.workOwner == this.contact.workOwner &&
          regexp.test(c.firstName)
      ).map(c => {
        return { id: c.idContactsContact, label: c.firstName }
      });
    },
    startCompanySearch(event) {
      this.editingCompanyInit = event.target.value;
      this.editingCompany = true;
    },
    setCompanyContactClick(id) {
      this.contact.companyContact = id;
      const contact = this.$store.getters['contacts/get'](id);
      this.contact.company = contact.firstName;
      this.editingCompany = false;
      this.editingCompanyInit = '';
    },
    setCompanyContactClose(string) {
      this.contact.company = string;
      this.contact.companyContact = "";
      this.editingCompany = false;
      this.editingCompanyInit = '';
    },
    addInputEmail() {
      this.additionalData.emails.push({
        address: ""
      });
    },
    addInputPhone() {
      this.additionalData.phones.push({
        phoneAreaCode: "",
        phoneNumber: ""
      });
    },
    removeInputPhone(index) {
      this.additionalData.phones.splice(index, 1);
    },
    removeInputEmail(index) {
      this.additionalData.emails.splice(index, 1);
    },
    deleteEmail(index) {
      this.contact.otherContacts.emails.splice(index, 1);
      let contact = this.contact;
      this.$http
        .post("contact/removeemail", {
          idContact: this.contact.idContactsContact,
          otherContacts: this.contact.otherContacts
        }, {
          withCredentials: true
        })
        .then(response => {
          this.$store
            .dispatch("contacts/update", {
              vlf: this.$vlf("contacts"),
              obj: response.data.contact
            })
            .catch(error => console.log(error));
        })
        .catch(error => {
          /* Offline */
          Promise.all([
            this.$store.dispatch("contacts/update", {
              vlf: this.$vlf("contacts"),
              obj: contact
            }),
            this.$store.dispatch('offline/saveSyncTuple', {
              _vue: this,
              _class: "ContactsContact",
              _table: "contacts",
              mode: 'edit',
              type: 'obj',
              obj: contact
            }),
            // this.$anm22.saveSyncTuple(this, "ContactsContact", "edit", contact)
          ]);
        });
    },
    deletePhone(index) {
      this.contact.otherContacts.phones.splice(index, 1);
      let contact = this.contact;
      this.$http
        .post("contact/removephone", {
          idContact: this.contact.idContactsContact,
          otherContacts: this.contact.otherContacts
        }, {
          withCredentials: true
        })
        .then(response => {
          this.$store
            .dispatch("contacts/update", {
              vlf: this.$vlf("contacts"),
              obj: response.data.contact
            })
            .catch(error => console.log(error));
        })
        .catch(error => {
          /* Offline */
          Promise.all([
            this.$store.dispatch("contacts/update", {
              vlf: this.$vlf("contacts"),
              obj: contact
            }),
            this.$store.dispatch('offline/saveSyncTuple', {
              _vue: this,
              _class: "ContactsContact",
              _table: "contacts",
              mode: 'edit',
              type: 'obj',
              obj: contact
            }),
            // this.$anm22.saveSyncTuple(this, "ContactsContact", "edit", contact)
          ]);
        });
    },
    showMessageAndReturn(id) {
      this.$anm22.eventBus.$emit("world-headbar-show-message", {
        text: this.$anm22.strLang(
          this.lang,
          "Update successful",
          "Salvataggio avvenuto con successo"
        ),
        type: "suggestion"
      });
      this.afterSaveFn(id);
    },
    save() {
      const useReferrerContact = this.$anm22.getReferrerFlag(this.contact, this.$store);
      switch (this.mode) {
        case "new":
          /* Salvo l'oggetto nel db */
          this.contact.idContactsContact = this.contact.dbKey = this.$anm22.genLocalId();
          this.contact.userOwner = this.user.idWorldUser;

          /* Creo il feed */
          const feed = {
            creationDate: this.$moment().unix()
          };
          feed.idWorldMessageChannel = feed.dbKey = this.$anm22.genLocalId();
          this.contact.feed = feed.idWorldMessageChannel;
          /* Tags */
          this.contact.tags = [];
          this.contact.links = [];
          let feedReferent = null;
          let referentContact = null;
          if(this.contact.type == 2) {
            if(this.referentFirstName != '' && this.referentLastName != '' && useReferrerContact === 1) {
              referentContact = {};
              referentContact.idContactsContact = referentContact.dbKey = this.$anm22.genLocalId();
              referentContact.type = 1;
              referentContact.firstName = this.referentFirstName;
              referentContact.lastName = this.referentLastName;
              referentContact.userOwner = this.user.idWorldUser;
              referentContact.company = this.contact.firstName;
              referentContact.workOwner = this.contact.workOwner;
              referentContact.tags = [];
              referentContact.links = [];
              feedReferent = {
                creationDate: this.$moment().unix()
              }
              feedReferent.idWorldMessageChannel = feedReferent.dbKey = this.$anm22.genLocalId();
              referentContact.feed = feedReferent.idWorldMessageChannel;
            }
            else {
              this.contact.referrerFirstName = this.referentFirstName;
              this.contact.referrerLastName = this.referentLastName;
            }
          }
          if(this.contact.phoneNumber) {
            this.contact.phoneNumber = this.contact.phoneNumber.replace(/ /g, '');
          }
          if(this.additionalData.phones.length > 0){
            this.additionalData.phones.forEach(phone => {
                phone.phoneNumber = phone.phoneNumber.replace(/ /g, '');
            });
          }
          this.$http
            .post("contact/new", {
              contact: this.contact,
              referentContact: referentContact,
              additionalData: this.additionalData
            }, {
              withCredentials: true
            })
            .then(response => {
              this.$store
                .dispatch("contacts/update", {
                  vlf: this.$vlf("contacts"),
                  objs: [response.data.contact]
                }),
              this.$store
                .dispatch("contacts/update", {
                  vlf: this.$vlf("contacts"),
                  objs: [response.data.referentContact]
                })
                .then(() => {
                  this.showMessageAndReturn(
                    response.data.contact.idContactsContact
                  );
                })
                .catch(error => console.log(error));
            })
            .catch(error => {
              //Gestione contatti multipli offline 
              this.contact.otherContacts = this.additionalData;
              console.log("saving offline");
              Promise.all([
                this.$store.dispatch("contacts/update", {
                  vlf: this.$vlf("contacts"),
                  objs: [this.contact]
                }),
                this.$store.dispatch("contacts/update", {
                  vlf: this.$vlf("contacts"),
                  objs: [referentContact]
                }),
                this.$store.dispatch("messageChannels/update", {
                  vlf: this.$vlf("messageChannels"),
                  objs: [feed]
                }),
                this.$store.dispatch("messageChannels/update", {
                  vlf: this.$vlf("messageChannels"),
                  objs: [feedReferent]
                }),
                /* Salvo prima il feed e poi il contatto per mantenere la catena dei riferimenti */
                this.$store.dispatch('offline/saveSyncTuple', {
                  _vue: this,
                  _class: "WorldMessageChannel",
                  _table: "messageChannels",
                  mode: 'new',
                  type: 'obj',
                  obj: feed
                }),
                this.$store.dispatch('offline/saveSyncTuple', {
                  _vue: this,
                  _class: "WorldMessageChannel",
                  _table: "messageChannels",
                  mode: 'new',
                  type: 'obj',
                  obj: feedReferent
                }),
                this.$store.dispatch('offline/saveSyncTuple', {
                  _vue: this,
                  _class: "ContactsContact",
                  _table: "contacts",
                  mode: 'new',
                  type: 'obj',
                  obj: this.contact
                }),
                this.$store.dispatch('offline/saveSyncTuple', {
                  _vue: this,
                  _class: "ContactsContact",
                  _table: "contacts",
                  mode: 'new',
                  type: 'obj',
                  obj: referentContact
                }),
                // this.$anm22.saveSyncTuple(
                //   this,
                //   "WorldMessageChannel",
                //   "new",
                //   feed
                // ),
                // this.$anm22.saveSyncTuple(
                //   this,
                //   "ContactsContact",
                //   "new",
                //   this.contact
                // )
              ])
                .then(() => {
                  this.showMessageAndReturn(this.contact.idContactsContact);
                })
                .catch(error => console.log(error));
            });
          break;
        case "edit":
          if(this.contact.phoneNumber) {
            this.contact.phoneNumber = this.contact.phoneNumber.replace(/ /g, '');
          }
          if(this.additionalData.phones && this.additionalData.phones.length > 0) {
            this.additionalData.phones.forEach(phone => {
                phone.phoneNumber = phone.phoneNumber.replace(/ /g, '');
            });
          }
          if(this.contact.otherContacts.phones && this.contact.otherContacts.phones.length > 0) {
            this.contact.otherContacts.phones.forEach(phone => {
              phone.phoneNumber = phone.phoneNumber.replace(/ /g, '');
            });
          }
          this.$http
            .post("contact/edit", {
              contact: this.contact,
              additionalData: this.additionalData
            }, {
              withCredentials: true
            })
            .then(response => {
              this.$store
                .dispatch("contacts/update", {
                  vlf: this.$vlf("contacts"),
                  objs: [response.data.contact]
                })
                .then(() => {
                  this.showMessageAndReturn(
                    response.data.contact.idContactsContact
                  );
                })
                .catch(error => console.log(error));
            })
            .catch(error => {
              //Gestione contatti multipli offline 
              if(this.additionalData.emails.length > 0){
                if(!this.contact.otherContacts.emails) {
                   this.contact.otherContacts.emails = [];
                }
               this.additionalData.emails.forEach(email => {
                  this.contact.otherContacts.emails.push({address :email.address });
                });
              }
              if(this.additionalData.phones.length > 0){
                if(!this.contact.otherContacts.phones) {
                   this.contact.otherContacts.phones = [];
                }
               this.additionalData.phones.forEach(phone => {
                  this.contact.otherContacts.phones.push({ phoneAreaCode: phone.phoneAreaCode,phoneNumber: phone.phoneNumber});
                });
              }
              
              /* Salvo l'oggetto nel db */
              Promise.all([
                this.$store.dispatch("contacts/update", {
                  vlf: this.$vlf("contacts"),
                  objs: [this.contact]
                }),
                /* Sync update */
                this.$store.dispatch('offline/saveSyncTuple', {
                  _vue: this,
                  _class: "ContactsContact",
                  _table: "contacts",
                  mode: 'edit',
                  type: 'obj',
                  obj: this.contact
                }),
                // this.$anm22.saveSyncTuple(
                //   this,
                //   "ContactsContact",
                //   "edit",
                //   this.contact
                // )
              ])
                .then(() => {
                  this.showMessageAndReturn(this.contact.idContactsContact);
                })
                .catch(error => console.log(error));
            });
          break;
      }
    }
  },
  created() {
    if (!this.contact.otherContacts || this.contact.otherContacts.length == 0) {
      this.contact.otherContacts = {};
    }
    if(!this.contact.workOwner) {
      this.contact.workOwner = 0;
    }
  }
};
</script>
 
<style lang="scss" scoped>
.item {
  margin-bottom: 10px;
}
.input-elem {
  max-width: 200px;
}
.input-row {
  flex-wrap: nowrap;
  align-items: center;
}
.add {
  display: inline-block;
  width: 20px;
  height: 20px;
  margin-top: -3px;
  margin-left: 4px;
  cursor: pointer;
}
.label-input-radio {
  height: 20px;
  width: 20px;
  border: 1px solid #bbb;
  border-radius: 4px;
  font-size: 16px;
  padding: 1px 2px;
  cursor: pointer;
}
.box {
  box-sizing: border-box;
  display: inline-block;
  padding: 20px 20px 40px;
  text-align: center;
  vertical-align: top;
  width: 50%;
  .img {
    display: inline-block;
    padding: 20px 0 0;
    width: 48px;
  }
  .mode-title {
    color: #222;
    font-size: 24px;
    padding: 40px 10px 0;
  }
}
</style>
 